import gsap from 'gsap';
import { Container, Sprite, Ticker } from 'pixi.js';

import { Shared } from '../App';

export class RadialShine extends Container
{
    private container: Container;

    constructor()
    {
        super();

        this.container = new Container();
        this.addChild(this.container);

        const numRays = 12;

        for (let i = 0; i < numRays; i++)
        {
            const ray = new Sprite(Shared.assets.getTexture('radial-shine-ray'));

            ray.anchor.set(0, 0.5);
            this.container.addChild(ray);
            ray.rotation = (Math.PI * 2 / numRays) * i;
        }
    }

    public updateTransform(): void
    {
        super.updateTransform();
        const delta = Ticker.system.deltaTime;

        this.container.rotation += 0.03 * delta;
    }

    public async burst(): Promise<void>
    {
        gsap.killTweensOf(this.container);
        gsap.killTweensOf(this.container.scale);
        this.container.alpha = 0;
        this.container.scale.set(0);
        gsap.to(this.container.scale, { x: 1, y: 1, duration: 0.2, ease: 'linear' });
        await gsap.to(this.container, { alpha: 1, duration: 0.2, ease: 'linear' });
        gsap.to(this.container, { alpha: 0.5, duration: 0.2, ease: 'linear' });
    }
}
